
import { Product } from "@/types/product";
import { dido } from "./dido";
import { cw1 } from "./cw1";

export const convertersScalersProducts: Product[] = [
  dido,
  cw1
];
